import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

const InspectHeatPump = () => {
  return (
    <>
      <h1>Inspect Heat Pump</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          'HP_ENABLED',
          'HP_TYPE',
          'HP_ECOONE_API_IP',
          'HP_MODBUS_PORT',
          'HP_NOMINAL',
          'HP_TYPE_NIBE',
          'HP_TYPE_COMPRESSOR',
          'HP_com_ok',
          'HP_com_wite_ok',
          'HP_cnt_com_ok',
          'HP_cnt_com_err',
          'HP_cnt_com_write',
          'HP_cnt_com_write_ok',
          'HP_cnt_com_write_err',
          'HP_ON',
          'HP_INFO_Status',
          'HP_INFO',
          'HP_ACTUAL_POWER',
          'HP_ACTUAL_POWER_SET',
          'HP_TEMP',
          'HP_IN',
          'HP_FLEXIBILITY_POWER',
          'HP_FLEXIBILITY_ON',
          'HP_FLEXIBILITY',
          'HP_PV_FLEXIBILITY',
          'HP_PV_STABILITY',
          'HP_FLEXI_ROOM',
          'HP_FLEXI_HW',
          'HP_FLEXI_COOL',
          'HP_FLEXI_AN',
          'HP_ROOM_ON',
          'HP_ROOM_TEMP',
          'HP_HW_ON',
          'HP_HW_TEMP',
          'HP_HW_SET_TEMP',
          'HP_ENERGY_CONSUMED_TOTAL',
          'HP_ENERGY_CONSUMED_TOTAL_R',
          'HP_SOC_STOP',
          'HP_SOC_STOP_UTILITY',
          'HP_PRIORITY',
          'HP_BATTERY_BLOCK',
          'SP_HP_STATUS',
          'SP_HP_NOW_REDUCE_ON',
          'SP_HP_NOW_INCREASE_ON',
        ]}
      />
    </>
  );
};

export default InspectHeatPump;
